import { ArrowLeftOutlined } from '@ant-design/icons';
import { Heading } from '@mm/components';
import { useChatbotCRUDActions } from '@mm/state/actions/ChatbotCRUDActions';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import MainSelect from '../../components/MainSelect/MainSelect';
import { ModalInstanceProps } from '../interfaces';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import styles from './SelectFacebookPageModal.module.css';

type Props = ModalInstanceProps & {
  pages: EnhancedBillingPage[];
};

export const SelectFacebookPageModal = (props: Props) => {
  const { pages } = props;

  const { closeModal } = useModalActions();
  const history = useHistory();
  const chatbotCRUDActions = useChatbotCRUDActions();

  const [selectedPage, setSelectedPage] = useState<
    undefined | EnhancedBillingPage
  >(pages?.length ? pages[0] : undefined);

  const onGoClick = async () => {
    if (selectedPage?.activeBotId) {
      history.push(
        BotBuilderRoutes.dashboard.getLink({
          chatbotId: selectedPage?.activeBotId,
        }),
      );
    }
    if (selectedPage?.id) {
      const bots = await chatbotCRUDActions.retrieveAll(selectedPage.id);
      if (bots && bots.length) {
        history.push(
          BotBuilderRoutes.dashboard.getLink({
            chatbotId: bots[0].id,
          }),
        );
      }
    }

    closeModal();
  };
  return (
    <div className={styles.container}>
      <ModalHeader
        className={styles.header}
        childrenContainerClassName={styles.headerChildren}
        newStyle
      >
        <Heading
          size={2}
          text="Switch to another page"
          className={styles.heading}
        />
      </ModalHeader>
      <ModalBody className={styles.body}>
        <div className={styles.text}>
          Select another Facebook page in order to continue{' '}
        </div>
        <MainSelect
          className={styles.selector}
          value={selectedPage?.id}
          onChange={e => {
            setSelectedPage(
              pages.find(({ id }) => id === Number(e.target.value)),
            );
          }}
        >
          {pages.map(page => (
            <option key={page.id} value={page.id}>
              {page.name}
            </option>
          ))}
        </MainSelect>
      </ModalBody>
      <ModalFooter className={styles.footer}>
        <div className={styles.backToPaywall} onClick={() => closeModal()}>
          <ArrowLeftOutlined className={styles.arrowIcon} />
          Back to paywall{' '}
        </div>
        <PrimaryButton className={styles.goBtn} onClick={onGoClick}>
          Go
        </PrimaryButton>
      </ModalFooter>
    </div>
  );
};
